import Vue from 'vue';
import Vuetify from 'vuetify';
import { Amplify } from 'aws-amplify';
import App from './App.vue';
import router from './router';
import store from './router/store';
import awsconfig from './aws-exports';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css'

require('dotenv').config();

Vue.use(Vuetify); // Use the Vuetify plugin, not vuetify itself

Amplify.configure(awsconfig);
Vue.config.productionTip = false;
new Vue({
  vuetify: new Vuetify(), // Create a new Vuetify instance and assign it to vuetify
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
